import * as React from 'react';
import isNil from 'lodash/isNil';

import { FormField } from 'components/form';
import Input from 'components/inputs/input/Input';

import { __t, applyTranslations } from 'utils/language';
import { maxLength } from 'utils/validators';

applyTranslations(require('./profile-bio.i18n.json'));

import type { InfluencerProfileForm, TextEntry } from 'types';

interface Props {
  profile: InfluencerProfileForm,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const MAX_LENGTH_BIO = 600;
const MSG_KEY = 'profile_bio';

const ProfileBio: React.FC<Props> = ({
  profile,
  onChange
}) => {
  const handleFieldChange = (
    event: React.SyntheticEvent<TextEntry>
  ): void => {
    const target = event.currentTarget;
    const type = target.dataset?.type;
    const value = target.value ?? '';

    if (isNil(type)) {
      return;
    }

    onChange({
      [type]: value
    });
  };

  const renderInput = (): React.ReactNode => {
    const bio = profile?.pitch ?? '';

    return (
      <Input
        multiline
        value={bio}
        name="pitch"
        width="responsive"
        className="profile-bio__input"
        charCount={{
          curCount: bio.length,
          maxChars: MAX_LENGTH_BIO
        }}
        onChange={handleFieldChange}
        data={{ type: 'pitch' }}
      />
    );
  };

  return (
    <div className="profile-bio">
      <FormField
        label={__t(`${MSG_KEY}.labels.bio`)}
        labelType="highlighted"
        direction="column"
        showValidationIcon={false}
        className="profile-bio__field"
        validators={[
          maxLength(profile.pitch, MAX_LENGTH_BIO)
        ]}
      >
        {renderInput()}
      </FormField>
    </div>
  );
};

export default ProfileBio;
